import Card from "@/atoms/CardKeyWorkers";
import HorizontalBar from "@/atoms/HorizontalBar";
import VerticalBar from "@/atoms/VerticalBar";

import BuybackPrice from "@/public/first-time-buyers/buyback-price.svg?url";
import CreditScore from "@/public/first-time-buyers/credit-score.svg?url";
import Deposit from "@/public/first-time-buyers/deposit.svg?url";
import FixedRent from "@/public/first-time-buyers/fixed-rent.svg?url";
import FlexibleEligibility from "@/public/first-time-buyers/flexible-eligibility.svg?url";
import RentBecomesDeposit from "@/public/first-time-buyers/rent-becomes-deposit.svg?url";
import RentingToOwning from "@/public/first-time-buyers/renting-to-owning.svg?url";
import Trophy from "@/public/first-time-buyers/trophy.svg?url";
import UKResidency from "@/public/first-time-buyers/uk-residency.svg?url";

const FirstTimeBuyers = (): JSX.Element => {
  return (
    <section className="px-4 pt-12 pb-9 bg-white md:px-6 lg:px-0">
      <h3 className="mb-5 text-3xl font-bold lg:text-5xl text-landing-blue md:mb-3 lg:mb-5 xt-left text-center">
        Reasons why First-Time Buyers love Keyzy!
      </h3>
      <h4 className="mb-5 font-serif text-xl text-left lg:text-3xl text-landing-blue lg:mb-14 text-center">
        We know how hard it is to buy your first home
      </h4>

      <div className="block lg:h-[222px] lg:flex lg:flex-row lg:justify-center lg:mb-11">
        <Card title="You don’t need a deposit saved" size="big" image={Deposit} subtitle={""} />

        <HorizontalBar className="inline-block my-4 lg:hidden" />
        <VerticalBar className="hidden lg:inline-block " />

        <Card
          title="You don’t need a perfect credit score"
          size="big"
          image={CreditScore}
          subtitle={""}
        />
        <HorizontalBar className="inline-block my-4 lg:hidden" />
        <VerticalBar className="hidden lg:inline-block" />

        <Card
          title="Fixed Monthly Rent for 2 or 3 years"
          size="big"
          image={FixedRent}
          subtitle={""}
        />
        <HorizontalBar className="inline-block my-4 lg:hidden" />
      </div>

      <HorizontalBar className="hidden w-auto mx-20 lg:flex mb-11" />

      <div className="block lg:h-[222px] lg:flex lg:justify-center lg:flex-row lg:mb-11">
        <Card
          title="Flexible Eligibility Criteria"
          size="big"
          image={FlexibleEligibility}
          subtitle={""}
        />

        <HorizontalBar className="inline-block my-4 lg:hidden" />
        <VerticalBar className="hidden lg:inline-block" />

        <Card
          title="Your rent becomes your deposit to buy"
          size="big"
          image={RentBecomesDeposit}
          subtitle={""}
        />
        <HorizontalBar className="inline-block my-4 lg:hidden" />
        <VerticalBar className="hidden lg:inline-block" />

        <Card title="Guaranteed Buyback Price" size="big" image={BuybackPrice} subtitle={""} />
      </div>

      <HorizontalBar className="hidden w-auto mx-20 lg:flex mb-11" />
      <HorizontalBar className="inline-block my-4 lg:hidden" />

      <div className="block lg:h-[222px] lg:flex lg:justify-center lg:flex-row lg:mb-11">
        <Card
          title="Easily Move From Renting to Owning"
          size="big"
          image={RentingToOwning}
          subtitle={""}
        />

        <HorizontalBar className="inline-block my-4 lg:hidden" />
        <VerticalBar className="hidden lg:inline-block" />

        <Card
          title="New Residents to the UK Welcome"
          size="big"
          image={UKResidency}
          subtitle={""}
        />
        <HorizontalBar className="inline-block my-4 lg:hidden" />
        <VerticalBar className="hidden lg:inline-block" />

        <Card title="Better Than A Traditional Mortgage" size="big" image={Trophy} subtitle={""} />
      </div>
      <div className="left-0 right-0 m overflow-hidden bg-repeat-x h-24 md:h-32 xl:h-48 bg-[url('/first-time-buyers/city-outline-mobile.svg')]  md:bg-[url('/key-workers/city-outline-tablet.svg')] xl:bg-[url('/key-workers/city-outline-desktop.svg')]" />
    </section>
  );
};

export default FirstTimeBuyers;
